import { Card, ListGroup } from 'react-bootstrap';
import { useFormat } from '../../../../components/FormatContext';

const SupplierPricingCard = ({ booking }) => {
    const { formatCurrency } = useFormat();
    return (
        <Card className="shadow-sm border-0">
            <Card.Header className="bg-white fw-semibold">Pricing Summary</Card.Header>
            <ListGroup variant="flush">
                <ListGroup.Item className="d-flex justify-content-between">
                    <span>Motorcycle Price</span>
                    <strong>{formatCurrency(booking.motorcyclePriceLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between">
                    <span>Extra Total</span>
                    <strong>{formatCurrency(booking.extraTotalLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between">
                    <span>Discount Total</span>
                    <strong>{formatCurrency(booking.discountTotalLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between">
                    <span>PVP Total</span>
                    <strong>{formatCurrency(booking.pvpTotalLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between">
                    <span>Paid</span>
                    <strong>{formatCurrency(booking.paidAmountLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between">
                    <span>Pending Amount</span>
                    <strong>{formatCurrency(booking.pendingAmountLabel, booking.currencyCode)}</strong>
                </ListGroup.Item>
            </ListGroup>
        </Card>
    );
};

export default SupplierPricingCard;